import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import { LoadingComponent } from '../../../../utils/newLoader';
import moment from 'moment';
import SaveAltRounded from '@material-ui/icons/SaveAltRounded';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
    '&:hover': {
      backgroundColor: "#d32f2f",
    }
  },
  colorRecord: {
    backgroundColor: "green",
  },
  pdfButton: {
    backgroundColor: "#d32f2f",
    color: "white",
    '&:hover': {
      backgroundColor: "#b71c1c",
    }
  }
}));

const screenCode = 'BANKCUSTOMERSLIPFILECREATE';

export default function BankCustomerSlipFile(props) {
  const [title, setTitle] = useState("Bank Customer Slip File");
  const classes = useStyles();
  const [bankSlipDetail, setBankSlipDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    date: moment(new Date()).format('YYYY-MM'),
    bank: 0,
  });
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routes, setRoutes] = useState();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [bankSlipData, setBankSlipData] = useState([]);
  const [effectiveDate, setEffetiveDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const today = moment(new Date()).format('YYYY-MM-DD');
  const [LastExecutionMonth, setLastExecutionMonth] = useState('');
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routeName: "0",
  })
  const [factoryCode, setFactoryCode] = useState('');
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();

  useEffect(() => {
    trackPromise(
      getPermission()
    );
    trackPromise(
      getGroupsForDropdown()
    );
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
  }, [bankSlipDetail.groupID]);

  useEffect(() => {
    trackPromise(getRoutesByFactoryID())
    if (bankSlipDetail.factoryID != 0) {
      trackPromise(getBalancepaymentLastdate())
    }
  }, [bankSlipDetail.factoryID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBANKCUSTOMERSLIPFILE');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setBankSlipDetail({
      ...bankSlipDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(bankSlipDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(bankSlipDetail.factoryID);
    setRoutes(routeList);
  }

  async function getBalancepaymentLastdate() {
    const dates = await services.getBalancepaymentLastdate(bankSlipDetail.groupID, bankSlipDetail.factoryID);
    var joinedDate = (dates.data[0].applicableYear + '-' + dates.data[0].applicableMonth)
    var lastExecutionYearMonth = moment(new Date(joinedDate)).format('YYYY-MM');
    setBankSlipDetail({
      ...bankSlipDetail,
      date: lastExecutionYearMonth
    });
    setLastExecutionMonth(lastExecutionYearMonth);
  }

  async function GetDetails() {
    const cropData = await services.GetBalancePaymentDetails(bankSlipDetail.groupID, bankSlipDetail.factoryID, bankSlipDetail.routeID, bankSlipDetail.date, bankSlipDetail.bank);
    getSelectedDropdownValuesForReport(bankSlipDetail.groupID, bankSlipDetail.factoryID, bankSlipDetail.routeID);
    if (cropData.statusCode == "Success" && cropData.data != null) {
      alert.success("Can download the slip file");
      setBankSlipData(cropData.data);
      if (selectedSearchValues.factoryName && selectedSearchValues.factoryName !== "0") {
        let factory = selectedSearchValues.factoryName.toUpperCase();
        let indexOfTEA = factory.indexOf('TEA');
        let charactersBeforeTEA = indexOfTEA !== -1 ? factory.substring(0, indexOfTEA) : factory;
        setFactoryCode(charactersBeforeTEA.trim());
      }
    }
    else {
      alert.error("No records found");
    }
  }

  function getSelectedDropdownValuesForReport(groupID, factoryID, routeID) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[groupID] || "All Groups",
      factoryName: FactoryList[factoryID] || "All Factories",
      routeName: routes && routes[routeID] ? routes[routeID] : "All Routes"
    });
  }

  const downloadTxtFile = () => {
    let formattedDate = moment(bankSlipDetail.date).format('YYMMMM');
    formattedDate = formattedDate.replace(/[a-zA-Z]+/, month => month.toUpperCase());

    let factory = ((selectedSearchValues.factoryName).toUpperCase())
    let indexOfTEA = factory.indexOf('TEA');
    let charactersBeforeTEA = indexOfTEA !== -1 ? factory.substring(0, indexOfTEA) : factory;
    const content = bankSlipData
      .map(row =>
        '0000' +   // Add 0000 as the first column 
        (row.customerBankCode !== null || undefined ? String(row.customerBankCode).padStart(4, '0') : '').substring(0, 4).padEnd(4) +
        (row.customerBranchCode !== null || undefined ? String(row.customerBranchCode).padStart(3, '0') : '').substring(0, 3).padEnd(3) +
        ((row.customerAccountNumber.length > 12) ? (row.customerAccountNumber !== null || undefined ? String(row.customerAccountNumber.slice(3)).padStart(12, '0') : '').substring(0, 12).padEnd(12)
        : (row.customerAccountNumber !== null || undefined ? String(row.customerAccountNumber).padStart(12, '0') : '').substring(0, 12).padEnd(12)) +
        (row.customerAccountName !== null || undefined ? String(row.customerAccountName) : '').substring(0, 20).padEnd(20) +
        (effectiveDate === today ? '52' : '23') +
        (row.transferAmount !== null || undefined ? String(parseFloat(row.transferAmount).toFixed(2)).replace('.', '').padStart(21, '0') : '').substring(0, 21).padEnd(21) +
        'SLR' +
        (row.factoryBankCode !== null || undefined ? String(row.factoryBankCode).padStart(4, '0') : '').substring(0, 4).padEnd(4) +
        (row.factoryBranchCode !== null || undefined ? String(row.factoryBranchCode).padStart(3, '0') : '').substring(0, 3).padEnd(3) +
        (row.factoryAccountNumber !== null || undefined ? String(row.factoryAccountNumber).padStart(12, '0') : '').substring(0, 12).padEnd(12) +
        (row.factoryAccountName !== null || undefined ? String(row.factoryAccountName) : '').substring(0, 20).padEnd(20) +
        (`BALANCEPAYMENT ${formattedDate}`).substring(0, 30).padEnd(30) +
        ((moment(effectiveDate).format('YYMMDD')).toUpperCase()).substring(0, 12).padEnd(12, '0')
      )
      .join('\n');

    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${charactersBeforeTEA}_${bankSlipDetail.bank == 1 ? "BOC" : "OB"}_SLIPS_BP${formattedDate}_${moment(effectiveDate).format('DD_MM_YYYY')}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const createPDFFile = () => {
    let formattedDate = moment(bankSlipDetail.date).format('YYMMMM');
    formattedDate = formattedDate.replace(/[a-zA-Z]+/, month => month.toUpperCase());
    
    let factory = selectedSearchValues.factoryName.toUpperCase();
    let indexOfTEA = factory.indexOf('TEA');
    let charactersBeforeTEA = indexOfTEA !== -1 ? factory.substring(0, indexOfTEA) : factory;
    
    return `${charactersBeforeTEA}_${bankSlipDetail.bank == 1 ? "BOC" : "OB"}_SLIPS_BP${formattedDate}_${moment(effectiveDate).format('DD_MM_YYYY')}.pdf`;
  };

  const getPageMargins = () => {
    return `@media print {
        @page {
            background-color: white !important;
            layout:A4;
        }
         body {
            background-color: white !important;
        }
    }`;
  };

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setBankSlipDetail({
      ...bankSlipDetail,
      [e.target.name]: value
    });
    setBankSlipData([]);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: bankSlipDetail.groupID,
              factoryID: bankSlipDetail.factoryID,
              routeID: bankSlipDetail.routeID,
              date: bankSlipDetail.date,
              effectiveDate: effectiveDate,
              bank: bankSlipDetail.bank
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                date: Yup.string().required('Select a date'),
                effectiveDate: Yup.string().required('Select a date'),
                bank: Yup.number().required('Bank is required').min("1", 'Bank is required'),
              })
            }
            onSubmit={() => trackPromise(GetDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              size='small'
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={bankSlipDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              size='small'
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={bankSlipDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              size='small'
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={bankSlipDetail.routeID}
                              variant="outlined"
                              id="routeID"
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="date">
                              Month *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.date && errors.date)}
                              fullWidth
                              helperText={touched.date && errors.date}
                              size='small'
                              name="date"
                              type="month"
                              onChange={(e) => handleChange(e)}
                              value={bankSlipDetail.date}
                              variant="outlined"
                              id="date"
                              inputProps={{ max: LastExecutionMonth }}
                            />
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="effectiveDate">
                              Transaction Effective Date *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.effectiveDate && errors.effectiveDate)}
                              fullWidth
                              helperText={touched.effectiveDate && errors.effectiveDate}
                              size='small'
                              name="effectiveDate"
                              type="date"
                              onChange={(e) => setEffetiveDate(e.target.value)}
                              value={effectiveDate}
                              variant="outlined"
                              id="effectiveDate"
                              inputProps={{ min: moment(new Date()).format('YYYY-MM-DD') }}
                            />
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="bank">
                              Bank *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.bank && errors.bank)}
                              fullWidth
                              helperText={touched.bank && errors.bank}
                              size='small'
                              name="bank"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={bankSlipDetail.bank}
                              variant="outlined"
                              id="bank"
                            >
                              <MenuItem value="0">--Select Bank--</MenuItem>
                              <MenuItem value="1">Bank of Ceylon</MenuItem>
                              <MenuItem value="2">Other Banks</MenuItem>
                            </TextField>
                          </Grid>
                          <Grid container justify="flex-end">
                            <Box pr={2}>
                              <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                              >
                                Search
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </CardContent>
                      {bankSlipData.length > 0 ?
                        <Box style={{ marginLeft: '25%', width: '50%', height:'340px'}}>
                          <Card >
                            <CardHeader 
                              style={{ 
                                textAlign: 'center', 
                                marginTop: '0.5rem', 
                              }} 
                              titleTypographyProps={{ variant: 'h5' }}
                              title={bankSlipDetail.bank == '1' ? "Generate Slip File For Bank of Ceylon" : "Generate Slip File For Other Banks"}
                            />
                            <Box display="flex" justifyContent='center' p={2} style={{ gap: '1rem' }}>
                              <Button
                                color="primary"
                                id="btnRecord"
                                variant="contained"
                                style={{ 
                                  backgroundColor: '#DFB710', 
                                  height: 40,
                                  minWidth: '200px'
                                }}
                                onClick={downloadTxtFile}
                                startIcon={<SaveAltRounded />}
                              >
                                DOWNLOAD TXT FILE
                              </Button>                      
                              <ReactToPrint
                                documentTitle={createPDFFile().replace('.pdf', '')}
                                trigger={() => (
                                  <Button
                                    color="primary"
                                    id="btnPDF"
                                    variant="contained"
                                    style={{ 
                                      backgroundColor: '#d32f2f', 
                                      height: 40,
                                      minWidth: '200px'
                                    }}
                                    startIcon={<PictureAsPdfIcon />}
                                    className={classes.pdfButton}
                                  >
                                    DOWNLOAD PDF
                                  </Button>
                                )}
                                pageStyle={getPageMargins()}
                                content={() => componentRef.current}
                              />
                            </Box>
                          </Card>
                        </Box>
                        : null}
                      <br></br>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
          <div style={{ display: 'none' }}>
            <CreatePDF 
              ref={componentRef}
              bankSlipData={bankSlipData}
              bankSlipDetail={bankSlipDetail}
              selectedSearchValues={selectedSearchValues}
              effectiveDate={effectiveDate}
              factoryCode={factoryCode}
            />
          </div>
        </Container>
      </Page>
    </Fragment>
  )
}